import { Fragment, useState } from "react";
import { ChevronsRight } from "react-feather";
import { Btn, H6, P } from "../../../../AbstractElements";
import { SmallModalButton } from "../../../../Constants/Constants";
import { FullScreenModalData } from "../../../../Data/UiKits/Modal";
import CommonModal from "../Common/CommonModal";

const SmallModal = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const data = {isOpen: modal,header: true,toggler: toggle,title: "Small modal",size: "sm",bodyClass: "dark-modal"};
  return (
    <Fragment>
      <Btn color="primary" onClick={toggle}>{SmallModalButton}</Btn>
      <CommonModal modalData={data}>
        {FullScreenModalData &&
          FullScreenModalData.slice(0, 3).map((item, index) => (
            <Fragment key={index}>
              <div className="large-modal-header">
                <ChevronsRight />
                <H6>{item.title}</H6>
              </div>
              <P className={`modal-padding-space ${index === 2 ? "mb-0" : ""}`}>{item.text}</P>
            </Fragment>
          ))}
      </CommonModal>
    </Fragment>
  );
};
export default SmallModal;
